/**
 * RewardDataGapNotice — Hinweis für die bekannte Reward-Datenlücke
 * (siehe src/lib/rewardDataGap.ts).
 *
 * Wird gezeigt, wenn eine angezeigte Periode/ein Datum innerhalb des
 * deklarierten Ausfallfensters liegt, damit eine 0/leere Anzeige nicht als
 * "keine Rewards verdient" missverstanden wird. Nutzt die bestehende globale
 * `.hint`-Optik (layout.css) statt neuer Markup-/Farb-Patterns.
 */
import type { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'
import { Info } from 'lucide-react'

type Props = {
  className?: string
  style?: CSSProperties
  /** Export-Kontext (CSV/Steuer-Jahresexport) statt Chart/Report-Ansicht. */
  variant?: 'default' | 'export'
}

export function RewardDataGapNotice({ className, style, variant = 'default' }: Props) {
  const { t } = useTranslation('common')

  return (
    <div
      className={className ? `hint ${className}` : 'hint'}
      style={style}
      role="status"
      data-testid="reward-data-gap-notice"
    >
      <Info size={14} aria-hidden="true" style={{ flexShrink: 0, marginTop: 1 }} />
      <span>{t(variant === 'export' ? 'rewardDataGap.messageExport' : 'rewardDataGap.message')}</span>
    </div>
  )
}
